export class AndroidAppDistDefinition {
    // アプリケーション名の最小、最大バイト
    public static readonly APPLICATION_NAME_MIN_LENGTH = 0;
    public static readonly APPLICATION_NAME_MAX_LENGTH = 256;
    // パッケージ名の最小、最大バイト
    public static readonly PACKAGE_NAME_MIN_LENGTH = 1;
    public static readonly PACKAGE_NAME_MAX_LENGTH = 256;
    // アプリケーション種別
    public static readonly APP_SETTING_TYPE_GOOGLE_PLAY = 0;    // Google Playストアから追加したアプリ
    public static readonly APP_SETTING_TYPE_FREE = 1;           // パッケージ名を手動入力して追加したアプリ
}
